/**
 * Enum Class
 * 
 * Returns an Enumerable.
 * Usage see ./EntityType.js
 *
 * @see https://stackoverflow.com/a/30759014
 * @export
 * @class Enum
 */
class Enum {
  constructor(obj) {
    const keysByValue = new Map();
    const EnumLookup = value => keysByValue.get(value);

    for (const key of Object.keys(obj)){
        EnumLookup[key] = obj[key];
        keysByValue.set(EnumLookup[key], key);
    }

    // Return a function with all your enum properties attached.
    // Calling the function with the value will return the key.
    return Object.freeze(EnumLookup);
  };
}

module.exports = {
  default: Enum
};